export interface RegistrationModelSerialResponse {
  status: any;
}
